/**
 * OrbDocTutorialsIntermediateUiPatternsSLOrbDocTutorialsIntermediateUiPatternsSLPage
 *
 * Page component for OrbDocTutorialsIntermediateUiPatternsSLOrbDocTutorialsIntermediateUiPatternsSLPage
 * Path: /sl/docs/tutorials/intermediate/ui-patterns
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsIntermediateUiPatternsSLDocScreenView as __OrbDocTutorialsIntermediateUiPatternsSLDocScreenView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsSLDocScreenView';
import { OrbDocTutorialsIntermediateUiPatternsSLDocAnalyticsView as __OrbDocTutorialsIntermediateUiPatternsSLDocAnalyticsView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsIntermediateUiPatternsSLOrbDocTutorialsIntermediateUiPatternsSLPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsIntermediateUiPatternsSLOrbDocTutorialsIntermediateUiPatternsSLPage(_props: OrbDocTutorialsIntermediateUiPatternsSLOrbDocTutorialsIntermediateUiPatternsSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Sestavljanje zaslona iz vzorcev","description":"Zgradi majhno nadzorno ploščo iz vzorcev postavitve, podatkov in povratnih informacij, z zavihki, ki menjajo telo.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/intermediate/ui-patterns"},{"locale":"ar","path":"/ar/docs/tutorials/intermediate/ui-patterns"},{"locale":"sl","path":"/sl/docs/tutorials/intermediate/ui-patterns"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsIntermediateUiPatternsSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsIntermediateUiPatternsSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsIntermediateUiPatternsSLOrbDocTutorialsIntermediateUiPatternsSLPage;
